import React from 'react'
import { Link } from 'react-router-dom'

import { useAtom } from 'jotai';
import './styles.scss'
import { openInviteMembersPageAtom } from 'containers/main/MainComponent';
import { createResourcePopupAtom, createSubscriptionPopupAtom, gettingStartedRightSideBarAtom } from 'showMessageMenuAtom';
import { GroupAppResource } from 'containers/LockScreen/domain';



const PageRedirectButton = ({ url, subdomain, group, btnLabel }: {
    url: string,
    subdomain: string,
    btnLabel?: string,
    group: any,
}) => {
    const [, setInviteMembers] = useAtom(openInviteMembersPageAtom);
    const [, setCreateResourcePopup] = useAtom(createResourcePopupAtom) as any;
    const [, setIsSubscriptionDetailsOpen] = useAtom(createSubscriptionPopupAtom);

    const linkUrl = (() => {
        if (url === 'settings/courses/create') {
            return subdomain
                ? "/settings/courses"
                : "/group/" + (group ? group.slug : '') + "/settings/courses";
        } else if (url === 'settings/library/create') {
            return subdomain
                ? "/settings/library"
                : "/group/" + (group ? group.slug : '') + "/settings/library";
        } else {
            return subdomain
                ? "/" + url
                : "/group/" + (group ? group.slug : '') + "/" + url;
        }
    })();
    const [, setIsRightSideBarOpen] = useAtom(gettingStartedRightSideBarAtom);

    return (
        <Link
            className="page-redirect-btn"
            // to={
            //     `${subdomain
            //         ? `/${url}`
            //         : `/group/${group && group.slug}/${url}`
            //     }`}
            to={linkUrl}
            onClick={() => {
                window.scrollTo(0, 0);
                setIsRightSideBarOpen(false);
                if (url === 'settings/members') {
                    setInviteMembers(true);
                }
                if (url === 'settings/courses/create') {
                    setCreateResourcePopup({
                        isOpen: true,
                        resourceType: GroupAppResource.COURSE,
                    })
                }
                if (url === 'settings/library/create') {
                    setCreateResourcePopup({
                        isOpen: true,
                    })
                }
                if (url === 'settings/subscriptions') {
                    setIsSubscriptionDetailsOpen(true);
                }
            }}
        >
            {btnLabel || 'Get started'}
        </Link>
    )
}

export default PageRedirectButton
